import { useEffect, useState } from "react";
import { getHostingsAccounts } from "../../../api/user/active-services/hostings";
import { errorMessage } from "../../../api/global";
import { DISPLAY_LANG } from "../../../config";
import { Link } from "react-router-dom";
import { pageTitle, hostingDetailBtn } from '../../../api/user/active-services/hostings';
import Loading from "../../../components/loading";
import "./hostings.css";

export default function Hostings() {
    const [hostings, setHostings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadingData = async () => {
            try {
                const data = await getHostingsAccounts();
                setHostings(data);
            } catch (error) {
                console.error(error);
                alert(errorMessage[DISPLAY_LANG]);
            } finally {
                setLoading(false);
            }
        };

        loadingData();
        window.scrollTo(0, 0);
    }, []);

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="hostings wrapper">
            <h1>{pageTitle[DISPLAY_LANG]}</h1>

            {hostings.accounts.length > 0 && (
                <div className="box-container">
                    {hostings.accounts.map((hosting) => (
                        <div className="box" key={hosting.id}>
                            <div className="inner">
                                <h2>{hosting.plan}</h2>
                                <p>({hosting.domain})</p>
                            </div>

                            <Link
                                to={`/user/hostings/${hosting.id}`}
                                key={hosting.id}
                            >
                                {hostingDetailBtn[DISPLAY_LANG]}
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
